import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useCurrentPathMatch = (paths: string[]) => {
    const [isMatch, setIsMatch] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsMatch(paths.some((path) => decodeURIComponent(location.pathname).includes(path)));
    }, [paths, location.pathname]);

    return isMatch;
};

export default useCurrentPathMatch;
